<template>
  <div>
    <span :class="['caption', requirementStatusTextClass]">
      <v-icon v-if="!isValid" color="red" size="small">mdi-close</v-icon>
      <v-icon v-if="isValid" color="green" size="small"
        >mdi-checkbox-marked-circle-outline</v-icon
      >
      {{ requirementText }}
    </span>
  </div>
</template>
<script setup lang="ts">
import { computed } from "vue";

const props = defineProps<{
  requirementText: string;
  isValid: boolean;
}>();

const requirementStatusTextClass = computed(() =>
  props.isValid ? "text-green" : "text-red"
);
</script>
